import React from 'react';
import PropTypes from 'prop-types';

const CheckBox = ({ name, id, value, onChange }) => {

  const handleChange = e => {

    onChange({
     target: {
       name,
       value: e.target.checked ? 1 : ''
     }
    })
  }

  return (
    <input type="checkbox" checked={value === 1} onChange={handleChange} id={id} className="!w-5 m-auto self-center"/>
  )
}

CheckBox.defaultProps = {
  value: 0,
  onChange: () => {}
}

CheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.instanceOf(Function)
}

export default CheckBox